<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div  class="bootstrap-wrapper">
    <div *ngIf="!error" id="onemap-report" class="project-detail-report">
        <div class="reportSectionHeader" *ngIf="reportData">
            <label>HOP Permit Number:&nbsp;</label>{{ reportData.permiT_NUM }}
        </div>
        <!-- Title Section -->
        <div class="reportSection" *ngIf="reportData">
            <div class="reportSectionHeader">
                <label>Title</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        {{ reportData.worK_DESC }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Location Section -->
        <div class="reportSection" *ngIf="reportData">
            <div class="reportSectionHeader">
                <label>Location</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-4">
                        <label>County:&nbsp;</label>{{ reportData.ctY_CODE }}
                    </div>
                    <div class="col-xs-4">
                        <label>Route:&nbsp;</label>{{ reportData.sT_RT_NO }}
                    </div>
                    <div class="col-xs-4">
                        <label>District:&nbsp;</label>{{ reportData.districT_NO }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Project Status Section -->
        <div class="reportSection" *ngIf="reportData">
            <div class="reportSectionHeader">
                <label>Project Status</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Status:&nbsp;</label>{{ reportData.applicatioN_STATUS_CODE_DESC }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Permit Subtype:&nbsp;</label>{{ reportData.permiT_SUB_TYPE_DESC }}
                    </div>
                    <div class="col-xs-6">
                        <label>Permit Issue Date:&nbsp;</label>{{ reportData.permiT_ISSUE_DATE.substring(0,9) }}

                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Planning Partner:&nbsp;</label>{{ reportData.plaN_PRTNR_SHRTNM }}
                    </div>
                    <div class="col-xs-6">
                        <label>Permit Expiration Date:&nbsp;</label>{{ reportData.permiT_EXPIRATION_DATE.substring(0,9) }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Segment:&nbsp;</label>{{ reportData.seG_BGN }}
                    </div>
                    <div class="col-xs-6">
                        <label>Permit Close Out Date:&nbsp;</label>{{ reportData.permiT_CLOSE_OUT_DATE.substring(0,9) }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Offset:&nbsp;</label>{{ reportData.offseT_BGN }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Legislative District Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                <label>Legislative District</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-4">
                        <label>PA House Districts</label>
                    </div>
                    <div class="col-xs-4">
                        <label>PA Senate Districts</label>
                    </div>
                    <div class="col-xs-4">
                        <label>US Congress Districts</label>
                    </div>
                </div>
                <div class="row" *ngIf="legData">
                    <div class="col-xs-4">
                        <a href="{{ legData.house.url }}" target="blank">{{ legData.house.nameDescription }}</a>
                    </div>
                    <div class="col-xs-4">
                        <a href="{{ legData.senate.url }}" target="blank">{{ legData.senate.nameDescription }}</a>
                    </div>
                    <div class="col-xs-4">
                        <a href="{{ legData.congress.url }}" target="blank">{{ legData.congress.nameDescription }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSection">
            <div class="reportSectionHeader">
                <label>Project Map</label>
            </div>
            <div class="reportSectionContent container">
                <div class="loader is-active padding-leader-3 padding-trailer-3" *ngIf="isLoadingMap">
                    <div class="loader-bars"></div>
                    <div class="loader-text">Loading...</div>
                </div>
                <div class="row" *ngIf="!isLoadingMap">
                    <div class="col-xs-12">
                        <div style="width:700px;height:300px;position:relative;">
                            <mc-map #mcMap></mc-map>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
